import CartCostBlock from './CartCostBlock'

export default CartCostBlock
